import React from "react";
import { Item } from "@coworker/apprestructured/src/shared/types/item";
import { ItemQuantityStepper } from "@coworker/apprestructured/src/media-maintenance/components/item-cards/ItemQuantityStepper/ItemQuantityStepper";
import { ItemDelete } from "@coworker/apprestructured/src/media-maintenance/components/item-cards/ItemDelete/ItemDelete";
import { Media } from "@coworker/app/src/components/RoomSettings/types/media";
import {
  Article,
  EdsData,
} from "@coworker/app/src/components/RoomSettings/types/article";
import { ItemBadge } from "@coworker/apprestructured/src/shared/types/ItemBadge";
import { Spacer } from "@coworker/apprestructured/src/shared/components/Spacer/Spacer";
import { ItemCardRenderType } from "@coworker/apprestructured/src/shared/types/itemCardRenderType";
import { MediaItemCardWithActions } from "@coworker/apprestructured/src/media-maintenance/components/item-cards/MediaItemCardWithActions/MediaItemCardWithActions";
import styles from "../../../styles/common-media-styles.module.css";
import { AggregatedArticle } from "@coworker/app/src/components/RoomSettings/hooks/useAggregatedArticles";
import { MediaItemViewType } from "@coworker/apprestructured/src/media-maintenance/types/mediaItemViewType";

interface MediaItemCardDefaultProps<T extends Article | AggregatedArticle> {
  item: Item;
  article: T;
  media: Media;
  selectArticleIdsMode?: boolean;
  itemCardRenderType: ItemCardRenderType;
  edsData?: EdsData | null;
  badges?: ItemBadge[];
  mediaItemViewType?: MediaItemViewType;
}

export const MediaItemCardDefault = <T extends Article | AggregatedArticle>({
  item,
  article,
  media,
  selectArticleIdsMode = false,
  itemCardRenderType = ItemCardRenderType.link,
  edsData,
  badges,
  mediaItemViewType = MediaItemViewType.SIMPLE_ITEM_VIEW,
}: MediaItemCardDefaultProps<T>) => {
  return (
    <MediaItemCardWithActions
      mediaItemViewType={mediaItemViewType}
      badges={badges || []}
      itemCardRenderType={itemCardRenderType}
      item={item}
      edsData={edsData ?? null}
      article={article}
      shouldDisplayQuantity={false}
      renderActions={() =>
        !selectArticleIdsMode ? (
          <>
            <Spacer />
            <div className={styles["item-card-action-row"]}>
              <ItemQuantityStepper
                itemNo={item.no}
                itemQuantityPieces={article?.nbrArticles ?? 0}
                article={article}
              />
              <ItemDelete
                itemNo={article.productArticleId}
                isItemInMultipleGroups={false}
                article={article}
                media={media}
              />
            </div>
          </>
        ) : null
      }
    />
  );
};
